<template>
  <div>
    <h3 class="md-title">
      <md-icon>trip_origin</md-icon>
      {{ $route.name }}
    </h3>
    <div class="md-layout">

      <!-- 검색 영역 -->
      <excutive-search-comp ref="searchComp"
          :levelList="orgLevelList"
          @setExcutiveData="onExcutiveSelected"
          @returnPagingResult="callbackPaging"
          @returnQueryResult="callbackQuery"
          @returnColumns="callbackColumns"
          >
        <div slot="bottomRightArea">
          <md-card-actions md-alignment="space-between">
            <div>
              <md-button class="md-info md-sm" @click="onClickWriteModeButton">
                <md-icon>person</md-icon>신규취임/업데이트퇴임 {{ isWriteMode ? "닫기" : "열기" }}
              </md-button>
              <md-button class="md-success md-sm" @click="downloadExcel">
                <md-icon>get_app</md-icon>Excel 다운로드
              </md-button>
              <md-button class="md-info md-sm" @click="newExecutiveInfo">
                <md-icon>person</md-icon>신규취임
              </md-button>
            </div>
          </md-card-actions>
        </div>

      </excutive-search-comp>
      <div id="scrollTargetBox"></div>
      <!-- 상세 영역 -->
      <excutive-detail-comp
          :show-executive-info-only = "showExecutiveInfoOnly"
          :isShow.sync="isShowDetail"
          :orgLevelList="orgLevelList"
          :excutive="selectedExecutive" >
      </excutive-detail-comp>

      <!--일괄처리 입력 영역-->
      <excutive-add-comp
          :isShow.sync="isWriteMode"
          :orgLevelList="orgLevelList" >
      </excutive-add-comp>

    </div>

  </div>
</template>

<script>

import kuaaFnc from "@/kuaa/kuaa-comm-func";

import ExcutiveSearchComp from "@/pages/Friendship/Components/ExcutiveSearchComp"
import ExcutiveDetailComp from "@/pages/Friendship/Components/ExcutiveDetailComp"
import ExcutiveAddComp from "@/pages/Friendship/Components/ExcutiveAddComp"
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import moment from "moment";

export default {
  components: {
    ExcutiveSearchComp,
    ExcutiveDetailComp,
    ExcutiveAddComp
  },

  created() {
    this.queryOrgLevelList();
  },

  mounted() {
    
  },
  
  computed: {
   
  },

  data() {
    return {
      kuaaFnc,
      orgLevelList: [], // 임원직위 목록
      
      isWriteMode: false, // 화면 모드 설정
      isShowDetail: false, // 임원단 상세와 이력
      showExecutiveInfoOnly : false,

      //isShowWrite: false, // 임원단 신규/업데이트 일괄 처리 영역

      selectedExecutive: { // 현재 목록에서 클릭된 임원
        memberNo: "",
        memberHnm: "",
        levelCd: "",
        erectDate: null,      //취임일
        expireDate: null,     //퇴임일
        reign: "",          //대수 
        memberjbGb: "",
        remark: ""
      },
      
      pagination: null,
      query: null,
      array: null

    };
        
  },
  methods: {
    
    /**
     * 임원 직위 공통코드 조회
     * 검색 조건에 assign
     */
    queryOrgLevelList() {
      kuaaFnc.fncOrgLevelList(null,res => {
         this.orgLevelList = res.data.data.contents;
      });
    },

    onExcutiveSelected(data) {
      this.isShowDetail = true;
      this.isWriteMode = false;
      this.showExecutiveInfoOnly = false;
      this.selectedExecutive = data;
      kuaaFnc.scrollTo('scrollTargetBox');
    },

    newExecutiveInfo(){
      this.isShowDetail = true;
      this.isWriteMode = false;
      this.showExecutiveInfoOnly = true;
      this.selectedExecutive = {
        isShowSave: true,
        wrkGb: "NEW",
        memberNo: "",
        memberHnm: "",
        levelCd: "",
        erectDate: moment().format("YYYYMMDD"),
        expireDate: null,
        reign: "",
        memberjbGb: "NN",
        remark: ""
      };
    },

    onClickWriteModeButton() {
      this.isWriteMode = !this.isWriteMode;
      this.isShowDetail = false;
    },

    callbackPaging(result){
      this.pagination = result;
    },

    callbackQuery(result){
      this.query = result;
    },
    
    callbackColumns(result){
    	this.array = result;
    },

    
    downloadExcel() {
      if(this.query == null){
        kuaaFnc.showSwal("Excel 다운로드", '검색후 진행해 주세요');
        return false;
      }
      this.query.page = 1;
      this.query.perPage = this.pagination.total;
      this.query.fileName = '임원단관리';
      this.query.test = this.array;
      kuaaApi.requestFileDownload(
          URL_CONST.ORG_EXCEL_DOWNLOAD,
          this.query,
          '임원단관리.xlsx',
          response => {
            this.query.page = this.pagination.page;
            this.query.perPage = this.pagination.perPage;
          }
      );
    }
  }
};
</script>

<style lang="css" scoped>

</style>